import React from "react";
import { Outlet } from "react-router-dom";
import * as S from "./styles";
import logo from "@/assets/svgs/logo.svg";
import MuiDrawer from "@mui/material/Drawer";
import {
  CSSObject,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Theme,
  styled,
} from "@mui/material";
import { FaAngleDoubleLeft, FaAngleDoubleRight } from "react-icons/fa";
import { menuData } from "./data";
import { Link } from "react-router-dom";

const drawerWidth = 240;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function Admin() {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <S.TopNav>
        <img src={logo} alt="Futscore" />
      </S.TopNav>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <IconButton onClick={() => setOpen((prev) => !prev)}>
            {open ? <FaAngleDoubleLeft /> : <FaAngleDoubleRight />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {menuData.map((el, index) => (
            <ListItem key={el.name} disablePadding sx={{ display: "block" }}>
              <S.CustomLink to={el.link}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    {React.createElement(el.icon)}
                  </ListItemIcon>
                  <ListItemText
                    primary={el.name}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </S.CustomLink>
            </ListItem>
          ))}
        </List>
      </Drawer>
      <S.SafeArea>
        <Outlet />
      </S.SafeArea>
    </>
  );
}
